import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { ENGLISH, ENGLISH_TRANSLATION, FRENCH, FRENCH_TRANSLATION, PRODUCT_ID } from 'src/util/constant';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';
import { inactivityTime } from 'base-frontend-components/dist/src/timeout-template/activity-logger';

import { AuthenticationService } from '../services/authentication.service';
import { RoutingEventService } from '../services/routing-event.service';
import { DataServices } from '../services/data.service';
import { SettingService } from '../services/setting.service';
import { StorageService } from '../services/storage.service';

import { LINKTYPES, SnackbarType } from './app-model/enums';
import SnackBar from '../shared/components/snackbar/snackbar';

import "base-frontend-components/dist/src/loaders/lazy-loader";
import "base-frontend-components/dist/src/loaders/lazy-loader";
import english from './app-config/english';
import french from './app-config/french';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'idqr-portal';
  @ViewChild('baseConfigRef', { static: true }) baseConfig: any;
  @ViewChild(ModalDirective, { static: false }) modal: ModalDirective;

  timeoutCountDown: number = 60;
  isTimedOut: boolean = false;
  showContextLazyloader: boolean = false;
  snackBar = new SnackBar();
  displayLogger: boolean = false;

  constructor(
    private settingService: SettingService,
    public translate: TranslateService,
    private storageService: StorageService,
    private authServices: AuthenticationService,
    private routeEvent: RoutingEventService,
    private router: Router,
    private dataService: DataServices
  ) {
    translate.addLangs(['en', 'fr']);
    const currentLanguage = translate.getBrowserLang();
    translate.use(currentLanguage);
    if (currentLanguage === 'fr') {
      StorageService.setTranslationLang(FRENCH)
    } else {
      StorageService.setTranslationLang(ENGLISH)
    }
  }

  ngOnInit(): void {
    this.storageService.setProductId(PRODUCT_ID);

    //Check if context exist or set a new one
    this.contextRouterEvent();

    this.initializeSettings();
    this.getTranslationJson();

    //  subscribe to user session; 
    this.dataService.userIdleSession$.subscribe(res => {
      if(res){
        inactivityTime(res.sessionTimeOut, res.countDown);
      }
    });

    // check if user has exceeded allowed time when they try to access a page directly
    let allowedTime = this.storageService.getUserAllowedTimeStamp();
    if(new Date().getTime() >  allowedTime?.allowedTime){
      if(this.displayLogger){
        this.logUserOut();
      }
    }
  }

  ngAfterViewInit(): void {
    let userData = this.storageService.getUserTimeOut();
    if (userData) {
      inactivityTime(userData.sessionTimeOut, userData.countDown);
    }
    this.inactivityLogger();
  }

  handler() {
    this.isTimedOut = false;
  }

  openLogger(countDown: number) {
    this.isTimedOut = true;
    this.timeoutCountDown = countDown;
    this.modal.show();
  }

  closeLogger() {
    this.modal.hide();
  }

  keepMeSignedIn() {
    this.closeLogger();
  }

  kickMeOut() {
    this.closeLogger();
    this.logUserOut();
  }

  logUserOut(){
    this.authServices.logout();
    this.routeEvent.goto(LINKTYPES.LOGIN);
    this.snackBar.create({
      text: 'Your session has expired. Please login again',
      duration: 9000,
      type: SnackbarType.WARNING,
    });
  }

  inactivityLogger() {
    window.addEventListener('inactivity-logger-event', (event: any) => {
      if(this.displayLogger){
        this.openLogger(event.detail.countdown);
      }
    });
  }

  initializeSettings() {
    // this.settingService.fetchSettings().subscribe((result) => {});
  }


  getTranslationJson() {
    let lang = this.storageService.getTranslationLang();
    let langTranslation = '';
    if (!lang) {
      langTranslation = ENGLISH_TRANSLATION;
    } else if (lang.toLowerCase() === ENGLISH) {
      this.translate.use('en');
      this.translate.currentLang = 'en';
      langTranslation = ENGLISH_TRANSLATION;
      this.baseConfig.nativeElement.mainAppJson(english);
    } else if (lang.toLowerCase() === FRENCH) {
      this.translate.use('fr');
      this.translate.currentLang = 'fr';
      langTranslation = FRENCH_TRANSLATION;
      this.baseConfig.nativeElement.mainAppJson(french)
    } else {
      this.translate.use('en');
      langTranslation = ENGLISH_TRANSLATION;
      this.translate.currentLang = 'en';
      this.baseConfig.nativeElement.mainAppJson(english);
    }

    // this.settingService.getTranslation(langTranslation).subscribe((result) => {
    //   if (result) {
    //     this.baseConfig.nativeElement.mainAppJson(result);
    //   }
    // });

    // this.translate.getTranslation(this.translate.currentLang).subscribe(translations => {
    //   this.baseConfig.nativeElement.mainAppJson(translations);
    // })

  }


  contextRouterEvent() {
    this.router.events.subscribe((event: RouterEvent) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.showContextLazyloader = true;
          break;
        }
        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.showContextLazyloader = false;
          break;
        }
        default: {
          break;
        }
      }
    });
  }
}
